import { getClassLevel } from "../shared/getClassLevel";

/** Existing Barbarian rules remain authoritative; this is registration only. */
const barbarianAdapter = Object.freeze({
  id: "barbarian",
  getClassLevel: (character) => getClassLevel(character, "barbarian"),
});

export default barbarianAdapter;
